import { Tooltip } from '@/components/basicComponents/tooltip';
import { currencyFormatter, currencyFormatterNoCents, formatCash } from '@/shared/utils/currency';

type FormattingTooltipProps = {
  children: number;
  zIndex?: number;
  noCent?: boolean;
  showDecimal?: boolean;
  disableTooltip?: boolean;
};

const FormattingTooltip = ({ children, zIndex, noCent = false, showDecimal = false, disableTooltip = false }: FormattingTooltipProps) => {
  return (
    <Tooltip
      title={noCent ? currencyFormatterNoCents.format(children) : currencyFormatter.format(children)}
      disableTooltip={children === null || disableTooltip}
    >
      {formatCash(children, showDecimal)}
    </Tooltip>
  );
};

export default FormattingTooltip;
